import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-005b2b18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-editor-element" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageEditorSection = _resolveComponent("PageEditorSection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.page.sections, ([key, sec]) => {
      return (_openBlock(), _createBlock(_component_PageEditorSection, {
        class: "page-section",
        key: key,
        section: sec,
        onExecute: _cache[0] || (_cache[0] = c => _ctx.$emit('execute', c))
      }, null, 8, ["section"]))
    }), 128))
  ]))
}